'use strict';

const SELECTOR = '.donation-block';

export function init() {
    const element = document.querySelectorAll(SELECTOR);

    if (!element.length) {
        return false;
    }

    document.addEventListener('click', function (event) {
        if (!event.target.classList.contains('btn--text')) return;
        var sp = document.querySelector('.donation-block__specific-amount');
        var ot = document.querySelector('.donation-block__other-amount');
        ot.classList.remove('hidden');
        sp.classList.add('hidden');
    }, false);

    document.addEventListener('submit', function (ev) {
        if (!ev.target.classList.contains('donation-block__inner')) {
            return;
        }
        ev.preventDefault();

        const amountField = ev.target.querySelector('.donation-block__specific-amount:not(.hidden) input:checked, .donation-block__other-amount:not(.hidden) input');
        const monthlyField = ev.target.querySelector('#monthly-donation').checked;
        if (!amountField) {
            alert('Please select/specify a donation amount');
        } else {
            document.location = `${ev.target.action}${ev.target.ct.value}/add-to-basket/${amountField.value}?monthly=${monthlyField}`;
        }
    });
}

export default { init }
